import { prepHandleEvent } from "./prepHandleEvent";
import { EventToCanvas } from "./EventToCanvas";

export function handleMouseEnter(canvas) {
  return function (event) {
    var rect = canvas.getBoundingClientRect();
    var p = EventToCanvas(event, rect.left, rect.top);

    var myApp = prepHandleEvent(this, false, null, null);
    if (myApp == null) return;

    myApp.HandleMouseEnter(p.x, p.y);

    event.stopPropagation();
    event.preventDefault();
  };
}
